import {HttpModelConverter} from '../../../../../core/converter/httpModel.converter';
import {ReportDefinitionSummaryModel} from '../reportDefinitionSummary.model';
import {AccountSummaryConverter} from '../../../../../account/common/api.converter/AccountSummary.converter';
import {UserSummaryConverter} from '../../../../../account/modules/user/api/converter/userSummary.converter';
import {Injectable} from '@angular/core';
import {LovValueSummaryConverter} from '../../../../../common/lov/lov-value/api/converter/LovValueSummary.converter';

@Injectable()
export class ReportDefinitionSummaryConverter extends HttpModelConverter<ReportDefinitionSummaryModel> {

    constructor(private lovValueSummaryConverter: LovValueSummaryConverter) {
        super();
    }

    protected createInstance(): ReportDefinitionSummaryModel {
        return new ReportDefinitionSummaryModel();
    }

    protected enrichObject(result: ReportDefinitionSummaryModel, src: ReportDefinitionSummaryModel) {
        result.account = new AccountSummaryConverter().convert(src.account);
        result.updatedBy = new UserSummaryConverter().convert(src.updatedBy);
        result.createdBy = new UserSummaryConverter().convert(src.createdBy);
        result.type = this.lovValueSummaryConverter.convert(src.type);
    }

}
